export default "__VITE_ASSET__0e32e5a8__"